import { Header } from "build-ts/metadata";
import React, { useState } from "react";
import { MetadataTypeEnum } from "build-ts/enums";
import { useConfigurationContext } from "context/ConfigurationContext";
import showToast from "hooks/useCustomToast";
import { deleteBenchmark } from "services/MetricService";
import MKGNodePopupComponent from "components/configuration/mkg/MKGNodePopupComponent";

interface MKGNodePopupContainerProps {
  header: Header;
  clickPos: { x: number; y: number };
  onClose: () => void;
}

const MKGNodePopupContainer: React.FC<MKGNodePopupContainerProps> = ({
  header,
  clickPos,
  onClose,
}) => {
  const [openDeleteBenchmark, setOpenDeleteBenchmark] = useState(false);

  const {
    deleteMetricById,
    deleteKgColumnById,
    setDependencies,
  } = useConfigurationContext();

  const handleDelete = async () => {
    const nodeType = header.type ?? MetadataTypeEnum.METRIC;
    if (nodeType === MetadataTypeEnum.METRIC) {
      await deleteMetricById(header.id!);
    } else if (nodeType === MetadataTypeEnum.BENCHMARK) {
      const res: any = await deleteBenchmark(header.id!);
      if (res) {
        setDependencies(res);
        setOpenDeleteBenchmark(true);
      } else {
        showToast("Benchmark deleted", "", "success");
      }
    } else if (nodeType === MetadataTypeEnum.KG_COLUMN) {
      await deleteKgColumnById(header.id!);
    }
    onClose();
  };

  return (
    <MKGNodePopupComponent
      header={header}
      clickPos={clickPos}
      onClose={onClose}
      handleDelete={handleDelete}
      openDeleteBenchmark={openDeleteBenchmark}
      closeDeleteBenchmark={() => setOpenDeleteBenchmark(false)}
    />
  );
};

export default MKGNodePopupContainer;
